"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mustache_1 = __importDefault(require("mustache"));
/**
  * Quick search functionality for navigation bar
  *
 */
const quickSearch = {
    el: {
        body: null,
        el: null,
        input: null,
        toggleButton: null,
        form: null,
        results: null,
        nav: null
    },
    results: {
        term: '',
        page: 1,
        total_hits: 0,
        hits: [],
        showAllResults: ''
    },
    templates: {
        results: ''
    },
    searchDelay: 500,
    minCharacters: 3,
    controller: new AbortController(),
    timer: null,
    processingClickEvent: null,
    /**
     * Initialises the functionality.
     * Attaches event handlers to toggle elements
     */
    init() {
        this.el = {
            body: document.querySelector('body'),
            el: document.getElementById('site-quick-search'),
            results: document.getElementById('site-quick-search-results'),
            toggleButton: document.querySelector('button[aria-controls="site-quick-search"]'),
            input: document.querySelector('[data-site-search-form] [name="search"]'),
            form: document.querySelector('[data-site-search-form]'),
            nav: document.querySelector('.navigation')
        };
        this.templates.results = document.getElementById('template-site-search-results')?.textContent || '';
        this.addEventListeners();
    },
    addEventListeners() {
        const self = this;
        this.el.toggleButton?.addEventListener('click', (e) => {
            const target = e.currentTarget;
            if (target?.getAttribute('aria-expanded') === 'false') {
                this.open();
            }
            else {
                this.closeSearch(false);
            }
        });
        // Handle search input events
        let oldValue = this.el.input?.value.trim();
        this.el.input?.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
                this.closeSearch(false);
                this.el.toggleButton?.focus();
            }
            const value = this.el.input?.value.trim() || '';
            if (oldValue === value) {
                return;
            }
            // Search value is too short
            if (value.length < this.minCharacters) {
                if (!value) {
                    this.emptyResults();
                }
                return;
            }
            oldValue = value;
            this.search(value);
        });
        // Close search when focus moves outside of search element
        this.el.body?.addEventListener('keyup', (e) => {
            if (e.key === 'Tab' && !this.el.el?.contains(e.target) && this.el.toggleButton?.getAttribute('aria-expanded') === 'true') {
                this.closeSearch(!e.shiftKey);
            }
        });
        window.addEventListener('click', function (e) {
            if (self.el.el?.classList.contains('hidden'))
                return;
            if (document.querySelector('.site-quick-search')?.contains(e.target) || document.querySelector('.js-search-toggle')?.contains(e.target)) {
                // Clicked in box
            }
            else {
                self.closeSearch(true);
            }
        });
        this.el.results?.addEventListener('click', (e) => {
            const target = e.target.classList.contains('site-quick-search-result') ? e.target : e.target.closest('.site-quick-search-result');
            if (target && target.dataset?.searchItem && target.dataset?.searchItemUrl === target.getAttribute('href')) {
                e.preventDefault();
                self.sendClickEvent({
                    url: target.getAttribute('href'),
                    id: target.dataset?.searchItem,
                    position: target.dataset?.searchItemPosition,
                    term: target.dataset?.searchItemTerm,
                });
                return false;
            }
        });
    },
    search(value) {
        this.controller.abort();
        this.controller = new AbortController();
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
            try {
                this.el.form?.classList.add('loading');
                fetch('/stage-ajax/siteSearch/?' + new URLSearchParams({
                    'stage-language': this.el?.form?.getAttribute('data-lang') || '',
                    context: 'quick_search',
                    search: value
                }).toString(), {
                    method: 'POST',
                    signal: this.controller.signal,
                })
                    .then(response => response.json())
                    .then((response) => {
                    response.showAllResults = this.el.form?.getAttribute('action') + '?search=' + response.term;
                    this.results = response;
                    this._renderResults();
                    this.showResults();
                    this.el.form?.classList.remove('loading');
                })
                    .catch((err) => {
                    console.error(`Search err error: ${err.message}`);
                    this.el.form?.classList.remove('loading');
                });
                return true;
            }
            catch (err) {
                if (err instanceof Error && err.name !== 'AbortError') {
                    console.log(err);
                    this.el.form?.classList.remove('loading');
                }
            }
            finally {
            }
        }, this.searchDelay);
    },
    sendClickEvent(data) {
        if (this.processingClickEvent) {
            return;
        }
        this.processingClickEvent = data.id;
        let locationChanging = false;
        const loadTargetPath = () => {
            if (data.url && !locationChanging) {
                locationChanging = true;
                window.location = data.url;
            }
        };
        try {
            fetch(`/stage-ajax/siteSearch/?stage-language=${document.body.getAttribute('data-language')}&context=reportClick`, {
                method: 'POST',
                signal: this.controller.signal,
                body: JSON.stringify({
                    id: data.id,
                    position: parseInt(data.position),
                    term: data.term
                }),
            }).then(() => {
                loadTargetPath();
            }).catch((err) => {
                loadTargetPath();
            });
            return true;
        }
        catch (err) {
            if (err instanceof Error && err.name !== 'AbortError') {
                console.log(err);
            }
        }
        // Navigate to new url after small delay, even if ajax request has not completed
        setTimeout(loadTargetPath, 500);
    },
    open() {
        this.el.toggleButton?.setAttribute('aria-expanded', 'true');
        this.el.el?.classList.remove('hidden');
        this.el.input?.focus();
        this.el.body?.classList.add('js-no-scroll');
        this.el.nav?.classList.add('navigation--search--open');
        // make sure mobilemenu gets closed
        const mobileMenu = document.getElementById('megamenu-mobile');
        if (mobileMenu) {
            document.querySelector('.js-megamenu-mobile-toggle');
            mobileMenu.classList.add("d-none");
            document.querySelector('.js-megamenu-mobile-toggle')?.classList.remove("open");
        }
        document.querySelectorAll("li.megamenu__link.open").forEach(el => el.classList.remove('open'));
        const megaMenuLinks = document.querySelectorAll('.js-megamenu-link');
        megaMenuLinks.forEach(el => el.setAttribute('aria-expanded', 'false'));
        document.querySelector('.navigation')?.classList.remove('navigation--open');
    },
    closeSearch(noFocus = false) {
        this.el.toggleButton?.setAttribute('aria-expanded', 'false');
        this.el.el?.classList.add('hidden');
        this.el.body?.classList.remove('js-no-scroll');
        this.el.nav?.classList.remove('navigation--search--open');
        if (!noFocus) {
            this.el.toggleButton?.focus();
        }
    },
    emptyResults() {
        if (this.el.results) {
            this.el.results.innerHTML = '';
            this.el.results?.classList.remove('open');
        }
    },
    /**
     * Render results view with current results.
     * @private
     */
    _renderResults() {
        const results = { ...this.results };
        if (this.el.results) {
            this.el.results.innerHTML = mustache_1.default.render(this.templates.results, results);
        }
    },
    /**
     * Shows results.
     */
    showResults() {
        if (!this.results.term) {
            return;
        }
        this.el.results?.classList.add('open');
    },
};
exports.default = quickSearch;
